import { createContext , useContext } from "react";

const AlertsContext = createContext();

const AlertsContextProvider = AlertsContext.Provider;

const useAlertContext = () => useContext(AlertsContext);

export { AlertsContextProvider , useAlertContext };